import { CALL_API, Schemas } from '../../../common/middleware/api';

export const FRANCHISOR_SETTINGS_FETCH_REQUEST = 'FRANCHISOR_SETTINGS_GET_REQUEST';
export const FRANCHISOR_SETTINGS_FETCH_SUCCESS = 'FRANCHISOR_SETTINGS_GET_SUCCESS';
export const FRANCHISOR_SETTINGS_FETCH_FAILURE = 'FRANCHISOR_SETTINGS_GET_FAILURE';

export const FRANCHISOR_SETTINGS_UPDATE_REQUEST = 'FRANCHISOR_SETTINGS_UPDATE_REQUEST';
export const FRANCHISOR_SETTINGS_UPDATE_SUCCESS = 'FRANCHISOR_SETTINGS_UPDATE_SUCCESS';
export const FRANCHISOR_SETTINGS_UPDATE_FAILURE = 'FRANCHISOR_SETTINGS_UPDATE_FAILURE';


export const fetchFranchisorSettings = (id) => ({
	[CALL_API]: {
		types: [FRANCHISOR_SETTINGS_FETCH_REQUEST, FRANCHISOR_SETTINGS_FETCH_SUCCESS, FRANCHISOR_SETTINGS_FETCH_FAILURE],
		endpoint: `api/franchisorSettings/${id}`,
		schema: Schemas.FRANCHISOR_SETTINGS,
		replace: { replace: true }
	}
});

export const updateFranchisorSettings = (id, franchisorSettings) => ({
	[CALL_API]: {
		types: [FRANCHISOR_SETTINGS_UPDATE_REQUEST, FRANCHISOR_SETTINGS_UPDATE_SUCCESS, FRANCHISOR_SETTINGS_UPDATE_FAILURE],
		endpoint: `api/franchisorSettings/${id}`,
		method: 'PUT',
		request: franchisorSettings,
		schema: Schemas.FRANCHISOR_SETTINGS,
		form: 'franchisorSettingsForm'
	}
});